import { inject, Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { filter, switchMap, take, tap } from 'rxjs/operators';

import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';

import { AppRoutePath } from '../../../../app-route-path.enum';
import { EmptyStatesPath } from '../../../empty-states/empty-states-path.enum';
import { RoleFacade } from '../../role-facade/role.facade';

@Injectable({
  providedIn: 'root',
})
export class BasicRoleGuard implements CanActivate, CanActivateChild {
  private readonly router = inject(Router);
  private readonly roleFacade = inject(RoleFacade);
  private readonly msalBroadcastService = inject(MsalBroadcastService);

  canActivate(): Observable<boolean> {
    return this.checkBasicRole();
  }

  canActivateChild(): Observable<boolean> {
    return this.checkBasicRole();
  }

  private checkBasicRole(): Observable<boolean> {
    return this.msalBroadcastService.inProgress$.pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      take(1),
      switchMap(() => this.roleFacade.hasBasicRole$),
      tap((hasBasicRole) => {
        if (!hasBasicRole) {
          this.router.navigate([
            AppRoutePath.EmptyStatesPath,
            EmptyStatesPath.NoAccessPath,
          ]);
        }
      })
    );
  }
}
